import { useApiService } from "medere-ui-framework";

export function useHealthCheckService() {
  const { api } = useApiService();

  function healthcheck() {
    return api.get("/api/secured/medereendpoints/getVersion", {
      params: {
        token: "cfee9a61-e9e2-4deb-b017-46b6136c193a"
      }
    }).then((response) => {
      return response;
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  return {
    healthcheck
  };
}
